import { observable, action, computed } from 'mobx';
import { EventEmitter } from "events";

export default class EsportsLiveStore {
  defaultMatchup = {
    matchupId: null,
    showNotificationLiveStream: true,
    stickyTabBars: false,
    activeTab: null,
    selectedEvent: {
      videoFeeds: null,
      seriesId: null,
    },
    menuContentStyle: {
      transform: 'none',
      transition: 'none',
    }
  }
  
  defaultMiniPlayer = {
    matchupId: null,
    isShowMiniPlayer: false,
    showMiniPlayerOnLeaveMatchupPage: false,
    isPlaying: true,
    isMuted: true,
  }

  defaultLiveStreamNoDelayData = {
    liveStreamPositionTop: 0,
    scrollEventEmitter: new EventEmitter(),
    liveStreamLang: "",
  }

  @observable matchupData = this.defaultMatchup;

  @observable miniPlayerData = this.defaultMiniPlayer;

  @observable liveStreamNoDelayData = this.defaultLiveStreamNoDelayData;

  @observable needScrollToTop = false;

  @observable needsPositionReset = false;

  @observable needsReloadLiveStream = false;

  @observable betLocationTrackingLiveStreamPlay = null;

  @action updateMatchupData(data) {
    Object.assign(this.matchupData, data);
  }

  @action resetMatchupData() {
    this.matchupData = this.defaultMatchup;
  }
  
  @action updateMiniPlayerData(data) {
    Object.assign(this.miniPlayerData, data);
  }

  @action resetMiniPlayerData() {
    this.miniPlayerData = this.defaultMiniPlayer;
  }

  @action updateLiveStreamNoDelayData(data) {
    Object.assign(this.liveStreamNoDelayData, data);
  }

  @action updateNeedScrollToTop(value) {
    this.needScrollToTop = value;
  }

  @action updateNeedsPositionReset(value) {
    this.needsPositionReset = value;
  }

  @action updateNeedsReloadLiveStream(value) {
    this.needsReloadLiveStream = value;
  }

  @action updateBetLocationTrackingLiveStreamPlay(value) {
    this.betLocationTrackingLiveStreamPlay = value;
  }

  @action resetBetLocationTrackingLiveStreamPlay() {
    this.betLocationTrackingLiveStreamPlay = null;
  }

  @computed get matchupLiveTab() {
    return this.matchupData.activeTab;
  }
}


// WEBPACK FOOTER //
// ./src/app/stores/EsportsLiveStore.js